import { Button, FeaturedIcon, Modal } from '@unified-checkout/design-system';
import { TrashCan } from '@unified-checkout/design-system/icons/index';
import { useWidth } from '@unified-checkout/kit-components';
import { useState } from 'react';
import { IPasskey } from 'apps/customer/src/types';
import { format, parseISO } from 'date-fns';
import { useRemovePasskey } from 'apps/customer/src/services/inner_layout/passkey';
import { MOBILE_BREAKPOINT } from 'apps/customer/src/constants';

interface IPasskeyCardItemProps {
  passkey: IPasskey;
}

export const PassKeyCardItem = ({ passkey }: IPasskeyCardItemProps) => {
  const isMobile = useWidth(MOBILE_BREAKPOINT);
  const { mutate: removePasskeyMutation, isPending: isPendingRemovePasskey } =
    useRemovePasskey();

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const { device_info, id } = passkey;
  const formattedDate = device_info?.lastLoggedIn
    ? format(parseISO(device_info?.lastLoggedIn || ''), 'dd MMM yyyy')
    : null;

  const removePasskeyHandler = () => {
    removePasskeyMutation(id);
    setIsDeleteModalOpen(false);
  };

  return (
    <section>
      <section>
        <div className="flex flex-row gap-3 md:items-center md:w-full justify-between p-4 rounded-xl border border-[#EAECF0] bg-white ">
          <div className="md:flex md:flex-col md:gap-2 md:self-stretch">
            <p className="mb-1 text-gray-900 english-utility-label-compact-semibold">
              {device_info?.deviceName}
            </p>
            {formattedDate && (
              <p className="text-gray-600 english-body-sm-regular">
                Last logged in {formattedDate}
              </p>
            )}
          </div>

          <section className="flex gap-2 md:gap-3 md:items-center md:justify-end shrink-0">
            <Button
              text="Remove"
              size="sm"
              leadingIcon={TrashCan}
              variant="link"
              color="secondary"
              disabled={isPendingRemovePasskey}
              onClickHandler={() => setIsDeleteModalOpen(true)}
            />
            <Modal
              open={isDeleteModalOpen}
              onCloseHandler={() => setIsDeleteModalOpen(false)}
              closeOnClickOutside
              isMobile={isMobile}
              supportingText="By removing you will not be able to seamlessly login."
              title="Are you sure you want to remove passkey ?"
              headerIcon={
                <FeaturedIcon size="xl" color="red" icon={TrashCan} />
              }
              btnsProps={[
                {
                  text: 'Cancel',
                  onClickHandler: () => setIsDeleteModalOpen(false),
                },
                {
                  text: 'Remove passkey',
                  color: 'secondary',
                  variant: 'outlined',
                  onClickHandler: removePasskeyHandler,
                },
              ]}
            />
          </section>
        </div>
      </section>
    </section>
  );
};
